<template>
  <div class="slidebox">
    <div class="slidebox-activator" @click="toggle"><slot name="activator" v-bind:isOpen="open" /></div>
    <div class="slidebox-content" :style="styleItems" ref="content"><slot /></div>
  </div>
</template>

<script>
export default {
  name: 'SlideBox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    maxHeight: '0px',
    open: false
  }),
  computed: {
    styleItems() {
      return {
        maxHeight: this.maxHeight,
        overflow: 'hidden'
      };
    }
  },
  watch: {
    maxHeight() {
      this.open = this.maxHeight != '0px';
    },
    value(newVal) {
      this[newVal ? 'expand' : 'collapse']();
    }
  },
  mounted() {
    this.open = this.value;
    if (this.value) {
      this.maxHeight = 'none';
    }
  },
  methods: {
    toggle() {
      if (this.disabled) return false;

      if (this.maxHeight == '0px') {
        this.expand();
        this.$emit('change', true);
      } else {
        this.collapse();
        this.$emit('change', false);
      }
    },
    expand() {
      let scrollHeight = this.$refs.content.scrollHeight;
      this.maxHeight = `${scrollHeight}px`;
      setTimeout(() => (this.maxHeight = 'none'), 300);
    },
    collapse() {
      let scrollHeight = this.$refs.content.scrollHeight;
      this.maxHeight = `${scrollHeight}px`;
      setTimeout(() => (this.maxHeight = `0px`), 50);
    }
  }
};
</script>

<style lang="scss">
.slidebox {
  &-activator {
    cursor: pointer;
  }

  &-content {
    transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
  }
}
</style>
